function secondsToIso8601Duration(seconds: number): string {
  const wholeSeconds = Math.max(0, Math.floor(seconds));
  const hours = Math.floor(wholeSeconds / 3600);
  const minutes = Math.floor((wholeSeconds % 3600) / 60);
  const remainingSeconds = wholeSeconds % 60;

  let duration = "PT";
  if (hours > 0) {
    duration += `${hours}H`;
  }
  if (minutes > 0) {
    duration += `${minutes}M`;
  }
  if (remainingSeconds > 0) {
    duration += `${remainingSeconds}S`;
  }

  return duration === "PT" ? "PT0S" : duration;
}

export { secondsToIso8601Duration };
